module.exports = __webpack_public_path__ + "static/media/person3.f1e5659a.png";